import SpaceBetween from "@awsui/components-react/space-between";
import React, { useState } from "react";
import NavigationBar from "components/NavigationBar";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import Competition from "model/Competition";
import CompetitionsSelect from "components/CompetitionsSelect";
import CompetitionsHeader from "components/CompetitionsHeader";
import { CompetitionState } from "model/CompetitionState";
import { FlashbarProps } from "@awsui/components-react/flashbar/interfaces";
import RecalculatePointsButton from "pages/admin/pages/recalculate_points/components/RecalculatePointsButton";
import Box from "@awsui/components-react/box";
import Link from "@awsui/components-react/link";
import SubmitFlashbar from "components/SubmitFlashbar";


const RecalculatePointsPage: React.FC = () => {

    const [selectedCompetition, setSelectedCompetition] = useState<Competition>();
    const [buttonEnabled, setButtonEnabled] = useState(true);
    const [submitMessage, setSubmitMessage] = useState<FlashbarProps.MessageDefinition>();

    return (
        <SpaceBetween size="l">
            <NavigationBar />
            <Container
                header={
                    <Box variant={"span"}>
                        <Header variant="h1">Recalculate points</Header>
                        <Link variant={"info"} href={"/admin"}>Back</Link>
                    </Box>
                }
            >
                <SpaceBetween size={"m"}>
                    <CompetitionsSelect
                        selectedCompetition={selectedCompetition}
                        setSelectedCompetition={setSelectedCompetition}
                        disabledStates={[CompetitionState.NOT_STARTED]}
                    />
                    {selectedCompetition &&
                        <Container
                            variant={"default"}
                            header={<CompetitionsHeader competition={selectedCompetition} />}
                        >
                            <SpaceBetween size={"m"}>
                                {submitMessage && (
                                    <SubmitFlashbar
                                        submitMessage={submitMessage}
                                        setSubmitMessage={setSubmitMessage}
                                    />
                                )}
                                <RecalculatePointsButton
                                    competition={selectedCompetition}
                                    buttonEnabled={buttonEnabled}
                                    setButtonEnabled={setButtonEnabled}
                                    setSubmitMessage={setSubmitMessage}
                                />
                            </SpaceBetween>
                        </Container>
                    }
                </SpaceBetween>
            </Container>
        </SpaceBetween>
    )
};

export default RecalculatePointsPage;
